module.exports = __webpack_public_path__ + "img/icon-cleaner-cover.1f7675e5.png";